import React from 'react'

import Button from '../actions/Button'
import Panel from '../structure/Panel'
import Picker from './picker/Picker'

const ButtonSelector = ({ option, isSelected, onClick, inPanel, ...props }) => {
  let color = isSelected ? 'primary' : 'light5'
  if (!!inPanel && !!isSelected) color = 'light3'
  let borderStyle = !isSelected && 'dashed'
  if (!!inPanel && !isSelected) borderStyle = 'none'

  return (
    <Button color={color} onClick={onClick} transparent={!inPanel || !isSelected} borderStyle={borderStyle} {...props}>
      {option?.name || option}
    </Button>
  )
}

const Wrapper = ({ children, inPanel, ...props }) => {
  if (!inPanel) return children

  return (
    <Panel bgColor="light1" padding={0.1} {...props}>
      {children}
    </Panel>
  )
}

const ButtonPicker = ({ value, onChange, options, ...props }) => {
  return (
    <Wrapper {...props}>
      <Picker
        hideSelecteds
        options={options}
        value={value}
        onChange={onChange}
        Selector={params => <ButtonSelector {...props} {...params} />}
        wrap
        direction="row"
        gap={props.inPanel ? 0.1 : 0.5}
        {...props}
      />
    </Wrapper>
  )
}

export default ButtonPicker
